<!-- Header -->
<tgx-onboarding-implementation-header [loggedUser]="loggedUser" [companyName]="companyName" [userImg]="userImg">
</tgx-onboarding-implementation-header>

<div class="container">
  <div class="section mt-5">
    <p class="section__title">We are quietly waiting for you, don't worry</p>
    <div class="section__item border-bottom">
      <div class="row">
        <div class="col-12">
          <p class="xen-heading-4 mb-2">Integration status</p>
          <p class="section__item-subtit mb-4">
            Our Supply Relations team will be in touch with you regarding the API development you’ll need to complete to
            start working with us. As soon as the development is certified, you’ll have full access to the platform and
            all its tools. Let’s get cracking!
          </p>
          @if (!askContact) {
            <xen-btn
              [type]="'secondary'"
              [size]="'medium'"
              [label]="'Contact Travelgate'"
              [id]="'button id'"
              [full_width]="false"
              [icon]="true"
              [icon_placement]="'right'"
              [icon_snippet]="'far fa-arrow-right'"
              [disabled]="false"
              [loading]="false"
              [skin]="'blue'"
              [tooltip_text]="'Lorem ipsum'"
              [tooltip_placement]="'top'"
              (click)="sendSupportRequest('Seller')"
            ></xen-btn>
          }
        </div>
      </div>
    </div>
  </div>
</div>
